<div class="app-container" [class.menu-collapsed]="!menuExpanded">
  <app-menu (menuStateChange)="onMenuStateChange($event)"></app-menu>
  <div class="page-container">
    <app-header class="header"></app-header>
    <div class="outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<router-outlet name="modal"></router-outlet>
